/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React from "react";
import {ExdsButton, ExdsLayout, ExdsLink, ExdsSpacing} from "@exds/core";
import { TuxModal } from '@tuxedo/react-component-library';
import {ExdsTheme} from "@exds/theme";
import './ButtonGroup.scss';

export default function ButtonGroup({advanceButtonContent, advanceButtonAction, isAdvanceButtonDisabled, modalButtonContent, modalButtonType, modalDetails, modalAction, backButtonContent, backButtonAction}) {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <>
      <ExdsSpacing margin="70px 0px 0px 0px">
        <ExdsLayout
          alignContent="flex-start"
          alignItems="center"
          display="flex"
          flexDirection="row"
          flexWrap="nowrap"
          gap="35px"
          justifyContent="flex-end"
          className="button-group-container"
        >
          {backButtonContent &&
            <ExdsLink
              href="#"
              textDecoration={[
                'underline'
              ]}
              textStyle="bodyMedium"
              onClick={() => {
                backButtonAction();
              }}
              className="back-link"
            >
              {backButtonContent}
            </ExdsLink>
          }
          {modalButtonType === 'button' && modalButtonContent &&
            <ExdsButton
              variant="secondary"
              minWidth="200px"
              type="button"
              text={modalButtonContent}
              onClick={() => setShowModal(true)}
            />
          }
          {modalButtonType === 'link' && modalButtonContent &&
            <ExdsLink
              href="#"
              className="link-button"
              textDecoration={[
                'underline'
              ]}
              textStyle="bodyMedium"
              onClick={() => {
                setShowModal(true);
              }}
            >
              {modalButtonContent}
            </ExdsLink>
          }
          { advanceButtonContent &&
          <ExdsButton
            className="advance-button"
            text={advanceButtonContent}
            variant="primary"
            disabled={isAdvanceButtonDisabled}
            {...(advanceButtonAction && { onClick: () => advanceButtonAction() })}
          />
          }
        </ExdsLayout>
      </ExdsSpacing>
      {
        modalDetails && <TuxModal
          open={showModal}
          type="popup"
          title={modalDetails.title}
          className='button-group-modal'
          body={<ExdsTheme>{modalDetails.body}</ExdsTheme>}
          footer={
            <ExdsTheme>
              <ExdsButton
                text={modalDetails.modalActionButton}
                variant="secondary"
                onClick={() => modalAction()}
              />
              <ExdsButton
                text={modalDetails.continueButton}
                variant="primary"
                onClick={() => setShowModal(false)}
              />
            </ExdsTheme>

          }
          onCloseModal={() => setShowModal(false)}
        />
      }
    </>
  );
}
